import { cn } from "@/lib/utils";
import { ExtensionLink } from "components/core/ExtensionLink";
import { Text } from "components/core/Text";
import { ComponentProps } from "react";

export const ContentTags = ({
    tags,
    color,
    className,
    ...props
}: {
    tags: Mix_ContentFragment["mix_content_tags"];
    color?: ComponentProps<typeof Text>["color"];
    className?: string;
}) => {
    return (
        <div
            className={cn("flex items-center overflow-hidden", className)}
            {...props}
        >
            {tags.map((tag, index) => (
                <span
                    key={tag.mix_content_tag_enum.value}
                    className="inline-flex items-center overflow-y-auto"
                >
                    <ExtensionLink
                        href={`/?tag=${tag.mix_content_tag_enum.value}`}
                        onClick={(e) => e.stopPropagation()}
                        className="group/tag flex w-max items-center
                            justify-center truncate text-ellipsis rounded-lg
                            bg-[#638FFF]/10 px-2 py-1 transition-all
                            duration-200 ease-out dark:bg-gray-700"
                    >
                        <Text
                            variant="body4"
                            className="text-blue-400 transition-all duration-200
                                ease-out group-hover/tag:font-bold
                                dark:text-blue-300"
                        >
                            {tag.mix_content_tag_enum.comment}
                        </Text>
                    </ExtensionLink>
                    {index < tags.length - 1 && <div className="mx-1" />}
                </span>
            ))}
        </div>
    );
};
